<template>
  <v-dialog v-model="dialog" >
    <div class="card card--white">
      <div class="card card--container">
        <div class="section-headers">Choose an exercise</div>
        <v-radio-group v-model="selectedExercise" style="height: 200px; overflow-y: scroll">
           <v-radio v-for="exercise in templateExercises" :key="exercise.id"
            :label="exercise.short_description"
            :value="exercise.id">
           </v-radio>
         </v-radio-group>
         <h-btn color="primary" :flat='true' @click="save">Save</h-btn>
         <h-btn :flat='true' @click="dialog=false">Cancel</h-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import dataStore from "@/services/api/store";
import snackbarHub from "@/services/hubs/snackbar";

export default {
  props: ["newExercise", "userId"],
  data() {
    return {
      dialog: false,
      selectedExercise: undefined,
      templateExercises: [],
      search: ""
    };
  },
  methods: {
    save() {
      if (!this.selectedExercise) {
        this.dialog = false;
      }
      const data = {
        template: this.selectedExercise,
        user: this.userId
      };
      dataStore.create("Task", data).then(() => {
        this.$emit("update");
        this.dialog = false;
        snackbarHub.update("Saved");
      });
    }
  },
  watch: {
    newExercise(newVal) {
      this.dialog = newVal;
    },
    dialog(newVal) {
      if (!newVal) {
        this.$emit("close");
      }
    }
  },
  created() {
    dataStore.findAll("TemplateTask").then(r => {
      this.templateExercises = r;
    });
  }
};
</script>

<style>
</style>
